module.exports = __webpack_public_path__ + "static/typeb-423d25705c0fb09a92ee9e890bf29285.png";